module.exports = __webpack_public_path__ + "assets/Catalog.d762982c.svg";